/**
 * PeopleYouMayKnow styles — section label + list + empty/error states (approved dark design).
 */

import { StyleSheet } from 'react-native'

export const peopleYouMayKnowStyles = StyleSheet.create({
  container: {
    gap: 10,
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: '#6B7280',
    paddingHorizontal: 4,
    paddingTop: 6,
  },
  list: {
    gap: 10,
  },
  emptyWrap: {
    alignItems: 'center',
    gap: 12,
    paddingVertical: 48,
    paddingHorizontal: 24,
  },
  emptyIconCircle: {
    width: 72,
    height: 72,
    borderRadius: 36,
    backgroundColor: 'rgba(68,38,152,0.25)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyTitle: {
    fontSize: 17,
    fontWeight: '700',
    color: '#F7FAFC',
    textAlign: 'center',
  },
  emptyBody: {
    fontSize: 14,
    color: '#9CA3AF',
    lineHeight: 20,
    maxWidth: 240,
    textAlign: 'center',
  },
  ctaButton: {
    marginTop: 4,
    backgroundColor: '#A78BFA',
    borderRadius: 10,
    paddingVertical: 11,
    paddingHorizontal: 20,
  },
  ctaLabel: {
    fontSize: 14,
    fontWeight: '700',
    color: '#111827',
  },
})
